var exports = {
  "Nr": "SubscriptionCard.module__card___Q2ctTG",
  "Vg": "SubscriptionCard.module__grid___Q2ctTG",
  "Qs": "SubscriptionCard.module__content___Q2ctTG",
  "wx": "SubscriptionCard.module__header___Q2ctTG",
  "DD": "SubscriptionCard.module__title___Q2ctTG",
  "h_": "SubscriptionCard.module__description___Q2ctTG",
  "h9": "SubscriptionCard.module__renewalInfo___Q2ctTG",
  "w$": "SubscriptionCard.module__pendingChangeInfo___Q2ctTG",
  "o1": "SubscriptionCard.module__actions___Q2ctTG",
  "hP": "SubscriptionCard.module__actionButton___Q2ctTG",
  "H2": "SubscriptionCard.module__legacyRateBadge___Q2ctTG",
};

module.exports = exports;
